import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CustomSelectField, CustomDateField } from '../../../components';
import formUtils from '../../../utils/formUtils';

function DeploymentSection({ militaryEnums, collected_attributes, intl, yesterdayDate, hasBeenDeployed }) {
  return (
    <>
      {collected_attributes.military_deployed && (
        <CustomSelectField
          name="military.deployed"
          id="uu_contact_military_deployed"
          label={<FormattedMessage id="mXwPa2" description="deployed" defaultMessage="Has ever been deployed?" />}
          options={formUtils.translateOptions(intl, militaryEnums.deployed)}
        />
      )}
      {hasBeenDeployed && (
        <div>
          <div className="inline-block w-40 mr-36">
            {collected_attributes.military_deployment_starts_at && (
              <CustomDateField
                name="military.deployment_starts_at"
                id="uu_military_deployment_starts_at"
                label={<FormattedMessage id="PYboOT" description="deploymentDates" defaultMessage="Deployment Dates" />}
                other={{ maxDate: yesterdayDate }}
              />
            )}
          </div>
          <div className="inline-block w-40">
            {collected_attributes.military_deployment_ends_at && (
              <CustomDateField
                name="military.deployment_ends_at"
                id="uu_military_deployment_ends_at"
                other={{ maxDate: yesterdayDate }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}

DeploymentSection.propTypes = {
  militaryEnums: PropTypes.object.isRequired,
  collected_attributes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  yesterdayDate: PropTypes.instanceOf(Date).isRequired,
  hasBeenDeployed: PropTypes.bool.isRequired,
};

export default DeploymentSection;
